module.exports = __webpack_public_path__ + "static/img/side1.66f1298.png";


//////////////////
// WEBPACK FOOTER
// ./static/newStatic/img/guide/side1.png
// module id = y1Vw
// module chunks = 88